import { render, staticRenderFns } from "./HsabExpenseCardRow.vue?vue&type=template&id=38faa8d2&scoped=true"
import script from "./HsabExpenseCardRow.vue?vue&type=script&lang=ts"
export * from "./HsabExpenseCardRow.vue?vue&type=script&lang=ts"
import style0 from "./HsabExpenseCardRow.vue?vue&type=style&index=0&id=38faa8d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38faa8d2",
  null
  
)

export default component.exports